import AnimatedActionButton from '../AnimatedActionButton';
import { motion } from 'framer-motion';

export default function ClientsHeroSection() {
  return (
    <section className="w-full bg-white min-h-[100svh] flex items-center">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-6xl font-light text-black leading-snug tracking-tight mb-12"
          style={{
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif',
          }}
        >
          We Help <span className="font-semibold">Great Companies</span>
          <br /> <br></br> 
          Build Even <span className="font-semibold">Greater Teams</span> .. <br></br> <br></br>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <AnimatedActionButton
            text="Work With Us"
            as="a"
            href="#"
            className="text-lg"
          />
        </motion.div>
      </div>
    </section>
  );
}
